const UPDATE_APPLIED_FILTER = 'estadisticas/filtros/UPDATE_APPLIED_FILTER';

export { UPDATE_APPLIED_FILTER };
